import React from 'react';
import { Check } from 'lucide-react';

import { cn } from '../../../../lib/utils';

// The client's progress, left to right on a computer; on a phone, the step
// they're on with a segmented bar (six circles don't fit a phone's width).
const JourneyTracker = ({ journey }) => {
  if (journey.closed) return null;
  const { steps } = journey;
  const at = steps.findIndex((s) => s.state === 'current');
  const current = steps[at] || steps[steps.length - 1];
  const doneCount = steps.filter((s) => s.state === 'done').length;
  return (
    <div className="rounded-2xl bg-white px-[18px] py-[16px] shadow-[0_1px_2px_rgba(15,23,42,0.04),0_2px_10px_rgba(15,23,42,0.06)] dark:!bg-slate-900 dark:ring-1 dark:ring-white/10 sm:px-[24px] sm:py-[24px]">
      {/* Phone */}
      <div className="sm:hidden">
        <div className="flex items-baseline justify-between gap-3">
          <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">
            {at >= 0 ? `Step ${at + 1} of ${steps.length}` : 'All steps done'}
          </div>
          <div className="text-[11px] font-semibold text-slate-400">{doneCount} done</div>
        </div>
        <div className="mt-1 text-base font-bold text-slate-900 dark:text-white">{current.label}</div>
        <div className="mt-3 grid grid-cols-6 gap-1">
          {steps.map((s) => (
            <span
              key={s.key}
              className={cn(
                'h-1.5 rounded-full',
                s.state === 'done'
                  ? 'bg-emerald-500'
                  : s.state === 'current'
                    ? 'bg-sky-500'
                    : 'bg-slate-200 dark:!bg-white/10',
              )}
            />
          ))}
        </div>
      </div>

      {/* Computer */}
      <ol className="mb-0 hidden list-none grid-cols-6 pl-0 sm:grid">
        {steps.map((s, i) => (
          <li key={s.key} className="relative flex flex-col items-center text-center">
            {/* The line to the next step, behind the circles. */}
            {i < steps.length - 1 ? (
              <span
                aria-hidden
                className={cn(
                  'absolute left-1/2 top-[15px] h-[2px] w-full',
                  s.state === 'done' ? 'bg-emerald-500' : 'bg-slate-200 dark:!bg-white/10',
                )}
              />
            ) : null}
            <span
              className={cn(
                'relative z-10 flex size-8 items-center justify-center rounded-full text-[13px] font-bold',
                s.state === 'done'
                  ? 'bg-emerald-500 text-white'
                  : s.state === 'current'
                    ? 'bg-sky-600 text-white ring-[5px] ring-sky-100 dark:ring-sky-500/20'
                    : 'bg-white text-slate-400 ring-2 ring-slate-200 dark:!bg-slate-900 dark:text-slate-500 dark:ring-white/10',
              )}
            >
              {s.state === 'done' ? <Check size={16} strokeWidth={3} /> : i + 1}
            </span>
            <span
              className={cn(
                'mt-2 px-1 text-[12px] leading-tight',
                s.state === 'current'
                  ? 'font-bold text-slate-900 dark:text-white'
                  : s.state === 'done'
                    ? 'font-semibold text-slate-600 dark:text-slate-300'
                    : 'text-slate-400 dark:text-slate-500',
              )}
            >
              {s.label}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default JourneyTracker;
